import {useNavigate, Route, Routes} from 'react-router';
import LayoutBox from './components/layout/Layout';

function Routing({user}) {
  let route = ''
  let location = window.location.pathname + window.location.search;
  const {is_authenticated} = user || '';
  let navigate = useNavigate();

  if (is_authenticated === true) {
    route = <Route path='/*'element={<LayoutBox/>}/>    
  } else if (is_authenticated === false) {
      //wymagaj logowania tylko dla /prawnik/*, /statystyki/ i /prawnik-portfel/*
      if (!location.match('/prawnik/') && !location.match('/statystyki/') &&
      !location.match('/prawnik-portfel/')) {
        route = <Route path='/*'element={<LayoutBox/>}/>
      } else {
        //nie wymagaj logowania dla /prawnik/ i /prawnik/<slug-z-liczbą>/ i zapłać portfelem
        if(!location.match(/prawnik(\/[0-9]+|([^-]+-[0-9]+))?\/$/) && !location.startsWith('/prawnik/zaplac-portfelem/') &&
            !location.match(/zaloguj/)) {
            route = navigate(`/zaloguj/?next=${location}`)
            window.location.reload()
        }
      }
    } else if (location.match('bezplatna-konsultacja-telefoniczna')) {
      route = <Route path='/*'element={<LayoutBox />}/>
    }

  if (location.match(/^\/[a-zA-Z-]+\/[a-zA-Z0-9-]+-[0-9]+\/$/)) {
    route = <Route path='/*' element={<LayoutBox />}/>
  }
  
  return (
    <Routes>
        {route}
    </Routes>
  )
}

export default Routing;